/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as i from "react";
import { useUnstyled as m, classNames as C, uCalendar as k } from "@progress/kendo-react-common";
const f = (e) => {
  const { className: l, firstDate: c, weekDays: n, ...o } = e, r = (a) => {
    const { onClick: t } = e;
    t && a && t.call(void 0, c, n || [], a);
  }, s = m(), d = s && s.uCalendar;
  return /* @__PURE__ */ i.createElement(
    "td",
    {
      className: C(k.td({ c: d, isWeek: !0 }), l),
      ...o,
      onClick: r
    },
    e.children
  );
};
export {
  f as CalendarWeekCell
};
